import React, { useState, useEffect, useRef } from "react";
import api from "../../services/api";
import moment from "moment";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import SearchWrapDiv from "../../components/common/SearchWrapDiv";
import SearchButton from "../../components/common/SearchButton";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import ListWrapDiv from "../../components/common/ListWrapDiv";
import FunctionButton from "../../components/common/FunctionButton";
import PageBar from "../../components/common/PageBar";
import InputWrapDiv from "../../components/common/InputWrapDiv";
import SearchInput from "../../components/common/SearchInput";
import MessageDialog from "../../components/common/MessageDialog";
import LoadingBoxDiv from "../../components/common/LoadingBoxDiv";
import FullModalDiv from "../../components/common/FullModalDiv";
import { Link } from "react-router-dom";
import { useMenuAuthInfo } from "../../services/GlobalUtil";
import { useTranslation } from "react-i18next";
import DealerCodeManagementEditModal from "./DealerCodeManagementEditModal";

const DealerCodeManagementPage = () => {
  const { t } = useTranslation();
  const menuAuthInfo = useMenuAuthInfo();
  const pageSize = 12;

  const [curPage, setCurPage] = useState(1);
  const [totalCount, setTotalCount] = useState();

  const [code, setCode] = useState("");
  const [cdDesc, setCdDesc] = useState("");
  const searchCode = useRef("");
  const searchCdDesc = useRef("");

  const [datas, setDatas] = useState([]);
  const [checkCodes, setCheckCodes] = useState([]);

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isSavedDialogOpen, setIsSavedDialogOpen] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editTarget, setEditTarget] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (menuAuthInfo.view) {
      loadContentData();
    }
  }, [curPage]);

  const loadContentData = () => {
    setIsLoading(true);

    api
      .post("/manage/dealercode/view", {
        searchCode: searchCode.current,
        searchCdDesc: searchCdDesc.current,
        pageNo: curPage,
        pageSize: pageSize,
      })
      .then((response) => {
        setTotalCount(response.data.totalCount);
        setDatas(response.data.content);
        setIsLoading(false);
      })
      .catch(() => {});
  };

  const handleSearch = () => {
    searchCode.current = code.trim();
    searchCdDesc.current = cdDesc.trim();

    if (curPage === 1) {
      loadContentData();
    } else {
      setCurPage(1);
    }
  };

  const pageChange = (data) => {
    if (curPage === data) {
      return;
    }
    setCurPage(data);
  };

  const handleCheckValue = (e) => {
    if (e.target.checked) {
      setCheckCodes((checkCodes) => [...checkCodes, e.target.value]);
    } else {
      setCheckCodes((checkCodes) =>
        checkCodes.filter((code) => code !== e.target.value)
      );
    }
  };

  const handleAdd = () => {
    setEditTarget(null);
    setIsModalOpen(true);
  };

  const handleEdit = (data) => {
    setEditTarget(data);
    setIsModalOpen(true);
  };

  const handleSaved = () => {
    setIsModalOpen(false);
    setCheckCodes([]);
    loadContentData();
    setIsSavedDialogOpen(true);
  };

  const handleDelete = () => {
    if (checkCodes.length === 0) {
      return;
    }
    setIsDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = () => {
    api
      .post("/manage/dealercode/delete", {
        ids: checkCodes,
      })
      .then(() => {
        loadContentData();
        setCheckCodes([]);
      })
      .catch(() => {});

    setIsDeleteDialogOpen(false);
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("MENU:L0056"), t("MENU:L1104")]}></BreadCrumbDiv>

      <SearchWrapDiv>
        <InputWrapDiv>
          <SearchInput
            width="170px"
            maxLength={16}
            placeholder={t("L1107")}
            value={code}
            onChange={(e) => setCode(e.target.value)}
          ></SearchInput>
          <SearchInput
            width="170px"
            maxLength={100}
            placeholder={t("L1106")}
            value={cdDesc}
            onChange={(e) => setCdDesc(e.target.value)}
          ></SearchInput>
          <SearchButton onClick={handleSearch}></SearchButton>
        </InputWrapDiv>
      </SearchWrapDiv>

      <ButtonWrapDiv className="btn_top">
        {menuAuthInfo.reg && (
          <FunctionButton
            value={t("L0321")}
            onClick={handleAdd}
          ></FunctionButton>
        )}
        {menuAuthInfo.del && (
          <FunctionButton
            className={"bg_gray"}
            value={t("L0091")}
            onClick={handleDelete}
          ></FunctionButton>
        )}
      </ButtonWrapDiv>

      <LoadingBoxDiv loading={isLoading}>
        <ListWrapDiv>
          <table>
            <colgroup>
              <col style={{ width: "4%" }} />
              <col style={{ width: "6%" }} />
              <col style={{ width: "18%" }} />
              <col style={{ width: "26%" }} />
              <col style={{ width: "16%" }} />
              <col style={{ width: "15%" }} />
              <col style={{ width: "15%" }} />
            </colgroup>
            <thead>
              <tr>
                <th></th>
                <th>{t("L0130")}</th>
                <th>{t("L1105")}</th>
                <th>{t("L1106")}</th>
                <th>{t("L1107")}</th>
                <th>{t("L1098")}</th>
                <th>{t("L1099")}</th>
              </tr>
            </thead>
            <tbody>
              {datas.length === 0 ? (
                <tr>
                  <td colSpan={7} style={{ textAlign: "center" }}>
                    {t("L0094")}
                    <br />
                    {t("L0095")}
                  </td>
                </tr>
              ) : (
                datas.map((data, rowIndex) => (
                  <tr key={rowIndex}>
                    <td>
                      <input
                        type="checkbox"
                        name="dealer-check"
                        id={`dealer-check-${data["id"]}`}
                        value={data["id"]}
                        onChange={handleCheckValue}
                        checked={checkCodes.includes(data["id"].toString())}
                      />
                      <label htmlFor={`dealer-check-${data["id"]}`}></label>
                    </td>
                    <td>{data.rowNum}</td>
                    <td>{data.type}</td>
                    <td>
                      {menuAuthInfo.view ? (
                        <Link to="#" onClick={() => handleEdit(data)}>
                          {data.cdDesc}
                        </Link>
                      ) : (
                        <span>{data.cdDesc}</span>
                      )}
                    </td>
                    <td>{data.code}</td>
                    <td>{data.creId}</td>
                    <td>
                      {data.date
                        ? moment(data.date).format("YYYY-MM-DD HH:mm:ss")
                        : ""}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </ListWrapDiv>

        <PageBar
          TotalCount={totalCount}
          CurrentPage={curPage}
          CountPerPage={pageSize}
          MaxPageBarCount={10}
          onPageСhange={pageChange}
        ></PageBar>
      </LoadingBoxDiv>

      <FullModalDiv
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        width="30%"
      >
        <DealerCodeManagementEditModal
          editTarget={editTarget}
          canEdit={editTarget === null ? menuAuthInfo.reg : menuAuthInfo.edit}
          onSaved={handleSaved}
        />
      </FullModalDiv>

      {isDeleteDialogOpen && (
        <MessageDialog title={t("L0339")} message={t("L0096")}>
          <FunctionButton
            className="bg_gray"
            value={t("L0005")}
            onClick={() => setIsDeleteDialogOpen(false)}
          ></FunctionButton>
          <FunctionButton
            value={t("L0004")}
            onClick={handleDeleteConfirm}
          ></FunctionButton>
        </MessageDialog>
      )}

      {isSavedDialogOpen && (
        <MessageDialog title={t("L0339")} message={t("L0103")}>
          <FunctionButton
            value={t("L0004")}
            onClick={() => setIsSavedDialogOpen(false)}
          ></FunctionButton>
        </MessageDialog>
      )}
    </div>
  );
};

export default DealerCodeManagementPage;
